"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const MoveReviewModalWrapper_1 = __importDefault(require("../components/MoveReviewModalWrapper"));
const withMoveReviewModal = (WrappedComponent) => {
    const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    const ComponentWithMoveReview = (props) => {
        return (react_1.default.createElement(MoveReviewModalWrapper_1.default, { clientId: props === null || props === void 0 ? void 0 : props.clientId, roundNumber: props === null || props === void 0 ? void 0 : props.roundNumber }, ({ handleOpenMoveReviewModal }) => (react_1.default.createElement(WrappedComponent, { ...props, openMoveReviewModal: handleOpenMoveReviewModal }))));
    };
    ComponentWithMoveReview.displayName = `withMoveReviewModal(${displayName})`;
    return ComponentWithMoveReview;
};
exports.default = withMoveReviewModal;
